import React, { Component } from "react";

import { roundToDecimals } from "../Utils";

import "../../../styles/components/utils/components/RadialProgress.scss";

class RadialProgress extends Component {
  progress(percentage) {
    return roundToDecimals(301.593 * percentage, 3);
  }

  render() {
    const curProgress = this.progress(this.props.value || 0);
    return (
      <svg
        id="radialProgress"
        className={this.props.value === -0.01 ? "grayscale" : ""}
        xmlns="http://www.w3.org/2000/svg"
        width={this.props.size || 120}
        height={this.props.size || 120}
        viewBox="0 0 120 120"
      >
        <defs>
          <filter
            id="grayscale"
            x="-20%"
            y="-20%"
            width="140%"
            height="140%"
            filterUnits="objectBoundingBox"
            primitiveUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feColorMatrix
              type="saturate"
              values="0"
              x="0%"
              y="0%"
              width="100%"
              height="100%"
              in="SourceGraphic"
              result="colormatrix"
            />
          </filter>
          <linearGradient
            id="a"
            x1="0%"
            y1="25%"
            x2="100%"
            y2="75%"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#2fffd1" />
            <stop offset="0.60" stopColor="#2fffd1" />
            <stop offset="1" stopColor="#1db795" />
          </linearGradient>
        </defs>
        <circle className="progress__meter" cx="60" cy="60" r="48" fill="none" strokeWidth="24" />
        <circle
          className="progress__value"
          cx="60"
          cy="60"
          r="48"
          fill="none"
          strokeWidth="24"
          strokeDasharray={`${curProgress} 301.593`}
        />
      </svg>
    );
  }
}

export default RadialProgress;
